/**
 * createProfile
 *
 * Create a new user profile.
 * This function creates a new profile containing user contact data that can be used
 * for personalizing Web2Print documents.
 */

import {useApi} from "~/composables";

export const createProfile = () => {
  const {
    mutate,
  } = useApi();

  const createProfileMutationQuery =`
    mutation createProfile($input: createProfileInput) {
      createProfile(input: $input) {
        id
        profile_name
        is_default
        user_id
        company
        text_field
        street
        postcode
        city
        phone
        email
        additional_address_data
        website
      }
    }
  `;

  const createProfile = async (variables) => {
    return await mutate(
      createProfileMutationQuery,
      variables
    )
  }

  return {
    mutation: createProfile,
  }
}
